import { render, staticRenderFns } from "./FormulateInputRichEditor.vue?vue&type=template&id=9640ff98&scoped=true&"
import script from "./FormulateInputRichEditor.vue?vue&type=script&lang=js&"
export * from "./FormulateInputRichEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormulateInputRichEditor.vue?vue&type=style&index=0&id=9640ff98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9640ff98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9640ff98')) {
      api.createRecord('9640ff98', component.options)
    } else {
      api.reload('9640ff98', component.options)
    }
    module.hot.accept("./FormulateInputRichEditor.vue?vue&type=template&id=9640ff98&scoped=true&", function () {
      api.rerender('9640ff98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/rich-editor/FormulateInputRichEditor.vue"
export default component.exports